module.exports = __webpack_public_path__ + "images/mstile-70x70-b4004e86691b01ab77370f9af9358093.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicons/mstile-70x70.png
// module id = ./src/images/favicons/mstile-70x70.png
// module chunks = 1